export default function initBanner(): void {
  Alpine.data('banner', () => ({
    init() {
      const banner = document.getElementById('banner-dialog');
      const bannerUid = this.$root.dataset.banner;
      if (banner && bannerUid) {
        window.addEventListener('elements:ready', () => {
          const closeBtns = banner.querySelectorAll('.banner-close');
          if (localStorage.getItem(`banner_${bannerUid}`) === null) {
            // @ts-expect-error tailwindcss dialog
            banner.show();
            closeBtns.forEach((btn) => btn.addEventListener('click', () => localStorage.setItem(`banner_${bannerUid}`, "closed")));
          }
        });
      }
    }
  }));
}
